import styles from "./Button.module.css";

interface Props {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const Button = ({ text, onClick, disabled }: Props) => {
  return (
    <button disabled={disabled} className={`${styles.button}`} onClick={onClick}>
      {text}
    </button>
  );
};
